import React, { useState } from 'react';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import MainContent from './components/MainContent';
import './App.css';

function App() {
  const [activeSection, setActiveSection] = useState('about');
  const [language, setLanguage] = useState('de');

  const handleSwitchSection = (section) => {
    setActiveSection(section);
  };

  const handleSetLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <div className="grid-container">
      <Header 
        activeSection={activeSection} 
        onSwitchSection={handleSwitchSection}
        language={language}
        onSetLanguage={handleSetLanguage}
      />
      <Sidebar language={language} />
      <MainContent 
        activeSection={activeSection} 
        onSwitchSection={handleSwitchSection}
        language={language} 
      />
    </div>
  );
}

export default App;